
/*
 * @Author: panweikang
 * @Date: 2024-01-04 15:23:35
 * @LastEditTime: 2024-07-13 14:45:18
 * @Description:
*/
import React, { useEffect, useRef, useState } from 'react'
import { Avatar, Image, Button, Toast } from 'antd-mobile'
import { MailOutline } from 'antd-mobile-icons'
import styles from './Barrage.module.scss'
import portraitPng from '../../static/mine/portrait.png'
import { getBarrageMessageApi } from '../../api/yearEndReportApi'

let Index = ({ items, speed = 20 }) => {

  const barrageRef = useRef(null);
  const [duration, setDuration] = useState(0);


  useEffect(() => {
    const calculateDuration = () => {
      const marqueeWidth = barrageRef.current.offsetWidth;
      console.log(barrageRef.current.offsetWidth)
      const calculatedDuration = marqueeWidth / speed;
      setDuration(calculatedDuration);
    };

    // 初次渲染后计算动画持续时间
    calculateDuration();

    // 监听窗口大小变化重新计算
    window.addEventListener('resize', calculateDuration);
    return () => window.removeEventListener('resize', calculateDuration);
  }, [items, speed]);

  return (
    <div className={styles.barrageContainer}>
      <div
        className={styles.barrage}
        style={{ animationDuration: `${duration}s` }}
        ref={barrageRef}
      >
        {
          items.map((item, index) => {
            let count = item.headImgUrls.length
            let width = `${(25 * count) - (25 / 2 * (count - 1))}px`
            return <div className={styles.barrageItem} key={index}>
              <div className={styles.portrait} style={{ width: width }}>
                {
                  item.headImgUrls.map((url, index) => {
                    return <Image
                      src={url}
                      width={25}
                      height={25}
                      fit="cover"
                      className={styles.portraitImage}
                      style={{ borderRadius: 12, left: index * 12.5 }}
                    />
                  })
                }
              </div>
              <div className={styles.barrageItemTip}>{item.content}</div>
            </div>
          })
        }

        {/* <div className={styles.barrageItem}>
          <div className={styles.portrait} style={{ width: '25px' }}>
            <Image
              src={portraitPng}
              width={25}
              height={25}
              fit="cover"
              className={styles.portraitImage}
              style={{ borderRadius: 12, left: 0 }}
            />
          </div>
          <div className={styles.barrageItemTip}>用户昵称哈哈哈哈 4分钟前拼团了</div>
        </div> */}
      </div>
    </div>

  )
}

export default Index
